module.exports = __webpack_public_path__ + "static/media/addToWallet.84dc6c7f.png";